/**
 * Returns an in-memory copy of a selected file.
 *
 * A File from an <input type="file"> is only a lazy reference to a file on disk. iOS/WebKit
 * can release that reference before the file is uploaded, which makes later reads return zero
 * bytes and the request body end up empty. Copying the bytes at selection time avoids this.
 *
 * @param {File} file - The file to copy.
 * @returns {Promise<File>} A File backed by an in-memory buffer.
 */
export const readFileIntoMemory = async (file) => {
  const buffer = await file.arrayBuffer();

  return new File([buffer], file.name, {
    type: file.type,
    lastModified: file.lastModified,
  });
};
